// extracted by mini-css-extract-plugin
export default {"box":"customSelect_box__0fWPv","box__select":"customSelect_box__select__g3J56","box__option":"customSelect_box__option__LF5xM"};